import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { statusSchedule } from 'app/core/data/calendar.json';
import { scheduleI, scheduleStatus } from 'app/core/interfaces/schedule';
import * as moment from 'moment';
import { DialogData } from 'app/core/interfaces/dialog';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { LayoutService } from 'app/core/http/services/layout.service';
import { AuthService } from 'app/core/http/services/auth.service';
import { EncounterService } from 'app/core/http/services/encounter.service';

@Component({
  selector: 'page-schedule-edit-status',
  templateUrl: './schedule-edit-status.component.html',
  styleUrls: ['./schedule-edit-status.component.scss'],
})
export class PatientScheduleEditStatusComponent implements OnInit {
  public status = 0;
  public scheduleStatus: scheduleStatus[] = statusSchedule;
  public schedule: scheduleI = <scheduleI>{};

  public encounter: any;
  public encounterFHIR: any;

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    public layout: LayoutService,
    private auth: AuthService,
    private encounterService: EncounterService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit(): void {
    if (this.data.param.encounter) {
      this.schedule = this.data.param.schedule;

      this.encounter = this.data.param.encounter;
      this.encounterFHIR = this.data.param.encounterFHIR;

      this.status = this.encounter.status ? this.encounter.status : 0;
    }
  }

  saveStatus() {
    this.encounterFHIR.status = this.status;

    this.encounterService.update(this.encounterFHIR.encounter_id, this.encounterFHIR).subscribe({
      next: (resEncounter) => {
        this.dialogRef.close(true);
      },
      error: (err) => {
        console.log('error', err);
      },
    });
  }
}
